import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { LaunchDarklyService } from './launchdarkly.service';

/**
 * Angular resolver that ensures the launchdarkly sdk is initialized before rendering the components.
 */
@Injectable()
export class LaunchDarklyResolver implements Resolve<boolean>  {

  constructor(private service: LaunchDarklyService) { }

  resolve(): Observable<boolean> {
    return this.service.initialized$;
  }
}
